/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { MSTGQLRef, QueryBuilder, withTypedRefs } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { CoordinatesSourceEnumType } from "./CoordinatesSourceEnum"
import { LocationStatusDtoModel, LocationStatusDtoModelType } from "./LocationStatusDtoModel"
import { LocationStatusDtoModelSelector } from "./LocationStatusDtoModel.base"
import { LocationStatusEnumType } from "./LocationStatusEnum"
import { RootStoreType } from "./index"


/* The TypeScript type that explicits the refs to other models in order to prevent a circular refs issue */
type Refs = {
  locationStatus: LocationStatusDtoModelType;
}

/**
 * VisitLocationDtoBase
 * auto generated base class for the model VisitLocationDtoModel.
 */
export const VisitLocationDtoModelBase = withTypedRefs<Refs>()(ModelBase
  .named('VisitLocationDto')
  .props({
    __typename: types.optional(types.literal("VisitLocationDto"), "VisitLocationDto"),
    id: types.identifier,
    address: types.union(types.undefined, types.string),
    originalAddress: types.union(types.undefined, types.null, types.string),
    latitude: types.union(types.undefined, types.null, types.number),
    longitude: types.union(types.undefined, types.null, types.number),
    geometryPoint: types.union(types.undefined, types.null, types.frozen()),
    active: types.union(types.undefined, types.boolean),
    bestMatch: types.union(types.undefined, types.null, types.boolean),
    locationStatusId: types.union(types.undefined, LocationStatusEnumType),
    locationStatus: types.union(types.undefined, MSTGQLRef(types.late((): any => LocationStatusDtoModel))),
    coordinatesSource: types.union(types.undefined, types.null, CoordinatesSourceEnumType),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  })))

export class VisitLocationDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get address() { return this.__attr(`address`) }
  get originalAddress() { return this.__attr(`originalAddress`) }
  get latitude() { return this.__attr(`latitude`) }
  get longitude() { return this.__attr(`longitude`) }
  get geometryPoint() { return this.__attr(`geometryPoint`) }
  get active() { return this.__attr(`active`) }
  get bestMatch() { return this.__attr(`bestMatch`) }
  get locationStatusId() { return this.__attr(`locationStatusId`) }
  get coordinatesSource() { return this.__attr(`coordinatesSource`) }
  locationStatus(builder: string | LocationStatusDtoModelSelector | ((selector: LocationStatusDtoModelSelector) => LocationStatusDtoModelSelector) | undefined) { return this.__child(`locationStatus`, LocationStatusDtoModelSelector, builder) }
}
export function selectFromVisitLocationDto() {
  return new VisitLocationDtoModelSelector()
}

export const visitLocationDtoModelPrimitives = selectFromVisitLocationDto().address.originalAddress.latitude.longitude.geometryPoint.active.bestMatch.locationStatusId.coordinatesSource
